import _ from "lodash";
import React, { useEffect, useState } from 'react';
import { FormGroup, Input } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { client_controller } from "../Controller/Cliente";
import { project_controller } from "../Controller/Project";


import '../css/popup.css';
import { spentHours_controller } from "../Controller/SpentHours";

import { helper } from "../Helper/helper";


function Popup(props) {

    //#region States

    const [projectId, setProjectId] = useState(0);

    const [spentHours, setSpentHours] = useState('');
    const [observation, setObservation] = useState('');

    const [clientList, setClientList] = useState([]);
    const [projectList, setProjectList] = useState([]);

    const [hours, setHours] = useState(null);

    const [date, setDate] = useState(null);

    //largura <800px
    var screenWidth = window.screen.availWidth;

    useEffect(() => { setDate(props.date) }, [props.date])

    //#endregion

    //#region Helper

    const handleOutsideClick = (modalId) => {
        if (modalId == 'popupId') {
            props.setTrigger(false);
        }
    }

    //#endregion

    //#region API Call
    function ListClient() {
        client_controller.list(function (sucess) {
            setClientList(sucess.filter(x => x.projectsName));
        });
    }

    useEffect(() => { ListClient() }, []);

    function ListProject(selectedClientName) {
        project_controller.list(selectedClientName, clientList, function (sucess) {
            setProjectList(sucess);
        });
    }

    function postDataApi() {
        console.log(projectId);
        spentHours_controller.create(projectId, date, spentHours, observation, function (sucess) {
            alert("Horas registradas com sucesso");
            props.setTrigger(false);
            props.func(helper.formatData(date));
            props.setDate(date)
        });
    }

    //#endregion

    if (screenWidth < 800) {
        return (props.trigger) ? (
            <div className="popup" id='popupId' onClick={((x) => { handleOutsideClick(x.target.id) })}>
                <div className="popupInner flex-box">
                    <div>
                        <form>
                            <fieldset >
                                <div className='col-md-12'>
                                    <h4>Horas Gastas</h4>
                                    <br />
                                    <div className='div-Title-Popup-Style'>
                                        <div className='popup-Title-Client'>
                                            <h5>Cliente</h5>
                                        </div>
                                        <div className='popup-Title-Project'>
                                            <h5>Horas</h5>
                                        </div>
                                    </div>
                                    <div className='popup-Div-Client-Hour-Field'>
                                        <div className="input-group has-validation mb-3 popup-Div-Input-Client-Style">
                                            <div style={{ width: '100%', color: 'black' }}>
                                                <FormGroup>
                                                    <Input type="select" onChange={(x) => { ListProject(x.target.value) }} tabIndex="0">
                                                        <option></option>
                                                        {clientList.map((item) => {
                                                            return (
                                                                <option value={item.clientName} >{item.clientName}</option>
                                                            );
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div className="input-group has-validation mb-3 popup-Div-Hour-Field">
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <TimePicker
                                                    ampm={false}
                                                    openTo="hours"
                                                    views={['hours', 'minutes']}
                                                    inputFormat="HH:mm"
                                                    mask="__:__"
                                                    value={hours}
                                                    onChange={((value) => { setHours(value); setSpentHours(helper.formatHours(value)); })}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            {/* <input type="time" className="form-control" onChange={((x) => { setSpentHours(x.target.value + ":00"); })} ></input> */}
                                        </div>

                                    </div>
                                    <div className='div-Title-Popup-Style' style={{ marginTop: '10%' }}>
                                        <div className='popup-Div-Project-Title'>
                                            <h5>Projeto</h5>
                                        </div>
                                        <div style={{ marginLeft: '37%', marginTop: '10%' }}>
                                            <h5>Data</h5>
                                        </div>
                                    </div>

                                    <div className='popup-Div-Client-Hour-Field'>
                                        <div className="input-group has-validation mb-3 popup-Div-Project-Field">
                                            <div style={{ width: '100%', color: 'black' }}>
                                                <FormGroup>
                                                    <Input type="select" required={true} onChange={(x) => { setProjectId(x.target.value); }} tabIndex="0">
                                                        <option></option>
                                                        {projectList.map((item) => {
                                                            return (
                                                                <option value={item.projectId}>{item.projectName}</option>
                                                            );
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div className="input-group has-validation mb-3 popup-Div-Hour-Field">
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    value={date}
                                                    inputFormat="dd/MM/yyyy"
                                                    onChange={(newValue) => {
                                                        setDate(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='popup-Title-Description'>
                                            <h5>Descrição</h5>
                                        </div>
                                        <input type="text" className="form-control popup-Input-Description-Field" onChange={((x) => { setObservation(x.target.value); })}></input>
                                    </div>
                                    <div className='popup-Div-Btn col-md-12'>
                                        <div>
                                            <button type="button" className="btn btn-secondary popup-Btn-Cancel-Style" onClick={() => props.setTrigger(false)}>Cancelar</button>
                                        </div>
                                        <div className='popup-Div-Btn-Save'>
                                            <button type="button" className="btn btn-secondary popup-Btn-Save-Style" onClick={(() => { postDataApi(); })}>Salvar</button>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        ) : "";
    } else {
        return (props.trigger) ? (
            <div className="popup" id='popupId' onClick={((x) => { handleOutsideClick(x.target.id) })}>
                <div className="popupInner flex-box">
                    <div className='div-Btn-Close-Popup'>
                        <button className="btn btn-secondary" onClick={() => props.setTrigger(false)}>X</button>
                    </div>
                    <div>
                        <form>
                            <fieldset >
                                <div className='col-md-12'>
                                    <h4>Horas Gastas</h4>
                                    <br />
                                    <div className='div-Title-Popup-Style'>
                                        <div className='popup-Title-Client'>
                                            <h5>Cliente</h5>
                                        </div>
                                        <div className='popup-Title-Project'>
                                            <h5>Horas</h5>
                                        </div>
                                    </div>
                                    <div className='popup-Div-Client-Hour-Field'>
                                        <div className="input-group has-validation mb-3 popup-Div-Input-Client-Style">
                                            <div style={{ width: '100%', color: 'black' }}>
                                                <FormGroup>
                                                    <Input type="select" onChange={(x) => { ListProject(x.target.value) }} tabIndex="0">
                                                        <option></option>
                                                        {clientList.map((item) => {
                                                            return (
                                                                <option value={item.clientName} >{item.clientName}</option>
                                                            );
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div className="input-group has-validation mb-3 popup-Div-Hour-Field" style={{ marginTop: '5px' }}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <TimePicker
                                                    ampm={false}
                                                    openTo="hours"
                                                    views={['hours', 'minutes']}
                                                    inputFormat="HH:mm"
                                                    mask="__:__"
                                                    value={hours}
                                                    onChange={((value) => { setHours(value); setSpentHours(helper.formatHours(value)); })}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            {/* <input type="time" className="form-control" onChange={((x) => { setSpentHours(x.target.value + ":00"); })} ></input> */}
                                        </div>
                                        <div>
                                            <div className='popup-Title-Description' style={{ marginTop: '-33px' }}>
                                                <h5>Descrição</h5>
                                            </div>
                                            <input type="text" className="form-control popup-Input-Description-Field" onChange={((x) => { setObservation(x.target.value); })}></input>
                                        </div>
                                    </div>
                                    <div className='div-Title-Popup-Style' >
                                        <div className='popup-Div-Project-Title'>
                                            <h5>Projeto</h5>
                                        </div>
                                        <div style={{ marginLeft: '42%', marginTop: '2%' }}>
                                            <h5>Data</h5>
                                        </div>
                                    </div>

                                    <div className='popup-Div-Client-Hour-Field'>
                                        <div className="input-group has-validation mb-3 popup-Div-Project-Field">
                                            <div style={{ width: '100%', color: 'black' }}>
                                                <FormGroup>
                                                    <Input type="select" required={true} onChange={(x) => { setProjectId(x.target.value); }} tabIndex="0">
                                                        <option></option>
                                                        {projectList.map((item) => {
                                                            return (
                                                                <option value={item.projectId}>{item.projectName}</option>
                                                            );
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div className="input-group has-validation mb-3 popup-Div-Hour-Field">
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    value={date}
                                                    inputFormat="dd/MM/yyyy"
                                                    onChange={(newValue) => {
                                                        setDate(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </div>
                                    <div className='popup-Div-Btn'>
                                        <div>
                                            <button type="button" className="btn btn-secondary popup-Btn-Cancel-Style" onClick={() => props.setTrigger(false)}>Cancelar</button>
                                        </div>
                                        <div className='popup-Div-Btn-Save'>
                                            <button type="button" className="btn btn-secondary popup-Btn-Save-Style" onClick={(() => { postDataApi(); })}>Salvar</button>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        ) : "";
    }
}
export default Popup;